export default __webpack_public_path__ + "static/media/facebookIcon.f7a3d7c2.svg";